import axios from "axios";

// remove _dev from file name
export default axios.create({
  baseURL:
    process.env.REACT_APP_COOLTORIAL_API_URL || "https://api.cooltorial2.cooltorial.it",
  baseBFFUrl:
    process.env.BFF_API_URL || "https://bff.cooltorial2.cooltorial.it",
  withCredentials: true,
});
